import React from 'react';
import { MsalProvider as MsalProviderLib } from '@azure/msal-react';
import { msalInstance } from '../services/msal';

function MsalProvider({ children }) {
    return <MsalProviderLib instance={msalInstance}>{children}</MsalProviderLib>;
}

export default MsalProvider;
